import { render, staticRenderFns } from "./support.datatable.vue?vue&type=template&id=ce059772&scoped=true&"
import script from "./support.datatable.vue?vue&type=script&lang=js&"
export * from "./support.datatable.vue?vue&type=script&lang=js&"
import style0 from "./support.datatable.vue?vue&type=style&index=0&id=ce059772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce059772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
